export default __webpack_public_path__ + "static/media/logo-black.41a4adf8.svg";